<script setup lang="ts">
/**
 * 版本角標：**per-game loading 畫面（新版，有開始鈕那個）左下角**三行版本號。
 * 順序固定 **server / cocos / web**（上→下）；🛑 **不印標籤**（使用者 2026-09-08 拿掉），
 * 只有版本號本身；取不到的那行顯示 `-`（行數固定，位置就是它的身分）。
 * 純顯示；來源見 useVersionInfo.ts。App.vue 塞進 LoadingScreen 的 slot
 * （slot 在 hostLoading 分支內 → legacy 全屏 logo 不出；absolute 貼 `.loading-frame`
 * 左下 = loading 背景圖左下），**生命週期 = 遮罩存活期間**，遮罩收掉跟著消失。
 * 🛑 不能綁 `!gameReadyReceived`：新版 UI 是 GAME_READY 後才切換的，綁了就互斥（曾踩）。
 * 顏色吃 `--color-string`（text-string）、大小 1.1rem（使用者 2026-09-07；專案 375 稿 1rem=10px → 11px）；無底色（黑底醜，使用者 2026-09-07 移除）。
 *
 * 🛑 **不能掛在 `.responsive-card` 內**：`.game-wrapper` 是 z-10 stacking context，
 *    z 逃不出去、會被 loading 遮罩（z-50）蓋死 —— 舊款遮罩收掉的瞬間就是 GAME_READY
 *    = badge 同時消失，可見窗口實際上是零（2026-09-07 修正）。要顯示就得在遮罩**裡面**
 *    （現行，貼 loading 圖）或 root 層 fixed z>50（會變 viewport 左下，已否決）。
 */
defineProps<{
  server: string
  cocos: string
  web: string
}>()
</script>

<template>
  <div
    class="pointer-events-none absolute bottom-0 left-0 z-20 select-none px-2 py-1 font-mono text-[1.1rem] leading-tight text-string"
    aria-hidden="true"
  >
    <div>{{ server }}</div>
    <div>{{ cocos }}</div>
    <div>{{ web }}</div>
  </div>
</template>
